import { TipoElementoEnum } from "../enum/tipo-elemento-enum";

export class ElementoVicinoDTO {

    idElemento: string;

    tipoElemento: TipoElementoEnum;
}
